import { Abonent } from '@shared/types/osi/abonents';

export interface IOsiSampleDocumentsWidgetViewModel {
  sortedAbonents: Abonent[];
  downloadDebtor: (abonent: Abonent) => Promise<void>;
  // mode — вариант расчёта долга на бэке (0=Current, 1=Overdue дефолт, 2=Collection)
  downloadNotary: (abonent: Abonent, mode?: number) => Promise<void>;
  isLoading: boolean;
}

export const IOsiSampleDocumentsWidgetViewModelToken = Symbol.for('IOsiSampleDocumentsWidgetViewModel');
